import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // If returning from Google OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and set the JWT itself.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("w2e_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("w2e_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("w2e_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const authenticateFromToken = (token, userObj) => {
    localStorage.setItem("w2e_token", token);
    setUser(userObj);
  };

  const logout = () => {
    localStorage.removeItem("w2e_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, authenticateFromToken, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
